import styled from "styled-components";

import { Grid, Container } from "@material-ui/core";

/* -------- Estilização ---------- */

const primary = (props) => props.theme.palette.primary;
const secondary = (props) => props.theme.palette.secondary;
const lightgreen = (props) => props.theme.palette.lightgreen;
const opensans = (props) => props.theme.fonts.opensans;
const mulish = (props) => props.theme.fonts.mulish;
const lightgrey = (props) => props.theme.palette.lightgrey;

export const PainelContainer = styled(Container)`
  margin-top: 100px;
  Button {
    span {
      font-family: ${opensans};
    }
    height: 100%;
  }
  .MuiIcon-root {
    font-family: "Material Icons" !important;
  }
`;

export const AriaInput = styled(Grid)`
  .MuiInputBase-root {
    input {
      font-family: ${opensans}, sans-serif !important;
    }
  }

  label {
    padding: 0px;
    font-family: ${opensans}, sans-serif !important;
  }

  .MuiFormControl-root {
    width: 100%;
  }

  .MuiButton-contained {
    width: 100%;
    height: 100%;
  }
`;

export const DataAria = styled.div`
  width: 100%;
  margin-top: 4vh;
  margin-bottom: 30px;
`;

export const BtnNewAria = styled.div`
  height: 7vh;
  Button {
    height: 100%;
  }
  margin-bottom: 20px;
`;

export const ButtonsAria = styled.div`
  Button {
    margin-bottom: 20px;
  }
`;

export const TableContent = styled.div`
  margin-top: 20px;
  padding: 12px;

  Header {
    margin-top: 10px;
  }

  Table {
    Thead {
      background-color: ${secondary};
      box-shadow: 3px 3px 3px ${(props) => props.theme.palette.darkgrey};
      tr {
        .Mui-checked {
          color: ${primary};
        }
        th {
          span {
            font-family: ${opensans}, sans-serif !important;
          }
        }
      }
    }
    Tbody {
      td {
        font-family: ${opensans}, sans-serif !important;
        font-size: 12px;
        .Mui-checked {
          color: ${primary};
        }
        .MuiChip-root {
          margin: 0;
        }
        Button {
          max-width: 40px !important;

          .MuiButton-startIcon {
            margin-left: 4px;
          }
        }
      }
      .Mui-selected {
        background-color: ${lightgreen};
        &:hover {
          background-color: ${lightgreen};
        }
        border: none;
      }
    }
  }
`;

export const Line = styled.div`
  height: 1px;
  width: 100%;

  margin-top: 10px;
  margin-bottom: 10px;

  background-color: ${secondary};
`;

export const HeaderAccordion = styled.div`
  width: 100%;

  .MuiChip-root {
    cursor: pointer;
    padding: 20px;
    width: 100%;
    margin: 0;
    span {
      font-weight: bolder;
      font-family: ${mulish};
      font-size: 1rem;
    }
  }
`;

export const HeaderVendaPagamentos = styled.div`
  width: 100%;

  .MuiChip-root {
    padding: 20px;
    width: 100%;
    margin: 0;
    span {
      font-weight: bolder;
      font-family: ${mulish};
      font-size: 0.9rem;
    }
  }

  .MuiTypography-body1 {
    font-weight: bold;
    border-bottom: 1px solid ${lightgrey};
    padding: 5px 0;
  }
`;
